<template >
  <div v-cloak v-if="!userType && loggedIn" id="page-wrap">
    <PageHeader :activeLink="'merchants'"></PageHeader>
    <div class="container content-wrap">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <QuickLinks class="hidden-xs"></QuickLinks>

          <div class="col-xs-12 content">
            <div class="row">
              <TransactionsDetailedHeader
                :calledOn="'shop'"
                :h1text="'Shop with Brands'"
                :ptext="'Start making purchase at these partners'"
                :style="{ 'background-image': `url(/static/images/svgs/shop/brands.svg)`,'background-repeat': 'no-repeat',
             'background-position': 'bottom right' }"
              ></TransactionsDetailedHeader>
            </div>
            <div v-if="categories.length" class="row tabHeader">
              <a
                @click="scrollPrev()"
                href="javascript:void(0)"
                class="col-xs-2 col-md-1 nav_ctrl hidden-xs text-right hidden-sm"
              >
                <img v-if="useSlider" src="/static/images/svgs/arrow.svg" width="16" alt="prev" />
              </a>
              <nav class="col-xs-12 categoriesTabsWrapper col-md-10">
                <ul class="list-inline categoriesList list-unstyled">
                  <li class="categoryTabs" v-for="(category, key) in categories">
                    <a
                      :class="{'active': activeCategory == category}"
                      @click="(e)=> activeCategory = category"
                      href="javascript:void(0)"
                    >{{category.categoryName}}</a>
                  </li>
                </ul>
              </nav>
              <a
                @click="scrollNext()"
                href="javascript:void(0)"
                class="col-xs-2 col-md-1 nav_ctrl hidden-xs text-left hidden-sm"
              >
                <img v-if="useSlider" src="/static/images/svgs/arrow.svg" width="16" alt="next" />
              </a>
            </div>
            <Slider v-if="activeCategory.promotions.length" :content="activeCategory.promotions"></Slider>

            <section class="merchantListWrapper">
              <ul class="list-inline list-unstyled">
                <li v-for="(merchant, index) in activeCategory.marketplaces">
                  <a
                    :href="merchant.marketplaceWebsiteUrl"
                    :id="generateSlug(merchant.marketplaceName)"
                    target="_blank"
                  >
                    <figure class="text-center merchant-fig">
                      <div class="img-wrap">
                        <img :src="merchant.marketplaceLogoUrl" :alt="merchant.marketplaceName" />
                      </div>
                      <figcaption>
                        <h4>{{merchant.marketplaceName}}</h4>
                      </figcaption>
                    </figure>
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <MobileNav :activeLink="'merchants'" class="visible-xs"></MobileNav>
    </div>
  </div>
</template>

<script>
import PageHeader from "./PageHeader/index";
import QuickLinks from "./QuickLinks/index";
import Slider from "./Slider/index";
import MobileNav from "./MobileNav/index";
import $ from "jquery";
import TransactionsDetailedHeader from "./TransactionsDetailedHeader/index";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Merchants",
  data() {
    return {
      activeCategory: undefined,
      widthArray: [],
      tabNaviPosition: 0,
      nextOffset: 0,
      navWidth: 0,
      leftOffset: 0,
      useSlider: false
    };
  },
  computed: {
    ...mapGetters(["categories", "userType", "loggedIn"])
  },
  components: {
    PageHeader,
    MobileNav,
    QuickLinks,
    TransactionsDetailedHeader,
    Slider
  },
  watch: {
    // whenever question changes, this function will run
    categories: function(newVal, oldVal) {
      this.setSlider(newVal);
    }
  },
  mounted() {
    this.$store.dispatch("merchants").then(response => {
      this.activeCategory = this.categories[0];
    });

    if (this.userType) {
      this.$router.push({ name: "Home" });
    }
  },
  created() {},
  methods: {
    generateSlug(label) {
      var labelArr = label.split(" ");
      return labelArr.join("-").toLowerCase();
    },
    setSlider(newVal) {
      if (typeof newVal == "object") {
        var totalCouponsWidth = 0,
          that = this;

        setTimeout(function() {
          that.navWidth = $(".categoriesList").innerWidth();

          $(".categoryTabs").each(function() {
            var elemWidth = $(this).outerWidth(true);
            totalCouponsWidth += elemWidth;
            that.widthArray.push(elemWidth);
          });

          if (totalCouponsWidth > that.navWidth) {
            that.useSlider = true;
          }

          $(".categoriesList").css({
            width: totalCouponsWidth + 100 + "px"
          });
        }, 1500);
      }
    },
    scrollPrev(disabled) {
      if (disabled) return;
      this.tabNaviPosition--;
      this.leftOffset = 0;
      for (var key in this.widthArray) {
        if (key > this.tabNaviPosition - 1) {
          break;
        }
        this.leftOffset += this.widthArray[key];
      }
      var leftOverArray = this.widthArray.slice(this.tabNaviPosition);
      this.nextOffset = 0;
      for (var i = this.tabNaviPosition; i < this.widthArray.length; i++) {
        this.nextOffset += this.widthArray[i];
      }
      $(".categoriesList").css({
        left: this.leftOffset * -1 + "px  "
      });
    },
    scrollNext(disabled) {
      if (disabled) return;
      this.leftOffset = 0;
      for (var key in this.widthArray) {
        if (key > this.tabNaviPosition) {
          break;
        }
        this.leftOffset += this.widthArray[key];
      }
      var leftOverArray = this.widthArray.slice(this.tabNaviPosition);
      this.nextOffset = 0;
      for (var i = this.tabNaviPosition; i < this.widthArray.length; i++) {
        this.nextOffset += this.widthArray[i];
      }
      $(".categoriesList").css({
        left: this.leftOffset * -1 + "px  "
      });
      this.tabNaviPosition++;
    }
  }
};
</script>
<style scoped lang="scss">
@import "../assets/sass/variables";

#page-wrap {
  background: #f5f6f7;
}

.categoriesList {
  left: 0;
  position: relative;
}
.categoriesTabsWrapper {
  overflow: auto;
  @media screen and (min-width: $md) {
    overflow: hidden;
  }
  @media screen and (max-width: $md) {
    display: block;
    margin: 0 -15px;
    width: 100vw;
    overflow: hidden;
  }
}

.nav_ctrl {
  box-shadow: none;
  line-height: 50px;
}

img[alt="prev"] {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
}
.content {
  @media screen and (min-width: $md) {
    background: #fff;
  }
  border-radius: 6px;

  .merchantListWrapper {
    margin: 40px 0;
    ul {
      margin: 0;
      padding: 0;
      -ms-box-orient: horizontal;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -moz-flex;
      display: -webkit-flex;
      display: flex;
      flex-wrap: wrap;
      li {
        -webkit-align-items: stretch;
        align-items: stretch;
        flex: 1 0 50%;
        @media screen and (min-width: $sm) {
          max-width: 50%;
          flex: 1 0 33.33%;
        }
        @media screen and (min-width: $md) {
          max-width: 25%;
          flex: 1 0 20%;
        }
        -ms-box-orient: horizontal;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -moz-flex;
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
        a {
          flex: 1 0;
          padding: 0 10px;
          align-items: center;
          -webkit-align-items: center;
          figure {
            .img-wrap {
              background: #fff;
              border-radius: 6px;
              position: relative;
              min-height: 130px;
              margin-bottom: 12px;
              border: solid 1px #f1f2f3;
              img {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                // transform:translate(-50%, -50%);
                // -moz-transform:translate(-50%, -50%);
                // -webkit-transform:translate(-50%, -50%);
                // -ms-transform:translate(-50%, -50%);
                // -o-transform:translate(-50%, -50%);
                max-width: 80%;
                max-height: 60px;
              }
            }
            figcaption {
              margin-bottom: 20px;
              h4 {
                margin: 0;
                font-family: Overpass;
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: -0.2px;
                text-align: center;
                color: #4b5566;
              }
              p {
                font-family: Overpass;
                font-size: 12px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #718099;
              }
            }
          }
        }
      }
    }
  }
  .tabHeader {
    border-bottom: solid thin rgba(75, 85, 102, 0.08);
    nav {
      overflow: hidden;

      @media screen and (max-width: $md) {
        overflow: auto;
        background: #fff;
        margin: 0 -15px;
        display: block;
      }
      ul {
        margin: 0;
        li {
          margin: 0 10px;
          a {
            display: block;
            line-height: 46px;
            margin: 0;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: -0.2px;
            text-align: left;
            border-top: solid 3px transparent;
            border-bottom: solid 3px transparent;
            box-sizing: border-box;
            color: #718099;
            &.active {
              border-bottom: solid 3px #fd7f5b;
            }
          }
        }
      }
    }
  }
}
.content-section {
  background-color: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: -10px;
  overflow: hidden;
  padding: 0;
  @media screen and (min-width: $md) {
    border-radius: 10px;
    margin-top: 0;
    min-height: 650px;
  }
  @media screen and (min-width: $md) {
    border-radius: 0px;
    background: white;
  }
  @media screen and (max-width: $md) {
    margin-top: 0;
    margin-bottom: 40px;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Merchants.vue